import * as Yup from "yup";
import { isValidPhoneNumber } from 'react-phone-number-input';
import { isPhoneEmptyOrValid } from 'utils/phoneUtils';

const optionalStringField = ({ min, max, reg, minMsg, maxMsg, regMsg }) => {
    return Yup.string()
        .nullable()
        .notRequired()
        .transform((value) => (value === "" ? null : value))
        .test("optional-string-validation", (value, context) => {
            if (value === null || value === undefined) return true;
            const strValue = String(value).trim();
            if (strValue === "") return true;
            if (min && strValue.length < min) {
                return context.createError({ message: minMsg });
            }
            if (max && strValue.length > max) {
                return context.createError({ message: maxMsg });
            }
            if (reg && !reg.test(strValue)) {
                return context.createError({ message: regMsg });
            }
            return true;
        });
};

const formValidationSchema = Yup.object().shape({
    firstName: optionalStringField({
        min: 2,
        max: 50,
        reg: /^[a-zA-Z\s'-]+$/,
        minMsg: "First name must be at least 2 characters",
        maxMsg: "First name must not exceed 50 characters",
        regMsg: "First name can only contain letters, spaces, hyphens, and apostrophes"
    }),
    email: Yup.string()
        .trim()
        .nullable()
        .notRequired()
        .test(
            'is-valid-email',
            'Please enter a valid email address',
            (value) => !value || /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
        ),

    phone: Yup.string()
        .nullable()
        .notRequired()
        .test(
            'is-valid-au-phone',
            'Please enter a valid phone number',
            (value) => isPhoneEmptyOrValid(value)
        ),
    country: optionalStringField({
        min: 2,
        max: 100,
        reg: /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s'&.-]+$/,
        minMsg: "Country name must be at least 2 characters",
        maxMsg: "Country name is too long",
        regMsg: "Please enter a valid country name"
    }),
});
export default formValidationSchema;
